import React, { useState } from 'react';
import { FaSync, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../../../services/api';
import { FinField, FinTextarea } from '../../../../components/FinField';
import { erroMotivoVolta, MOTIVO_VOLTA_MAX } from './voltaParaPlanosPolicy';

// D-0097: "Voltar para Planos de Pagamento" (Aprovados pelo Financeiro → 1ª aba do Custo Previsto).
// Um só modal para a aba Aprovados e para a tela de Detalhe da previsão. A API repete as travas
// (pago, travado, em Contas Pendentes) e avisa o operador e os responsáveis do evento.
//
// plano: { id, fornecedor, referencia } — onFechar(): fecha sem fazer nada; onConcluido(): depois da volta.
export default function ModalVoltaParaPlanos({ plano, onFechar, onConcluido }) {
    const token = localStorage.getItem('token');
    const [motivo, setMotivo] = useState('');
    const [salvando, setSalvando] = useState(false);
    const erroMotivo = erroMotivoVolta(motivo);

    const fechar = () => { if (!salvando) onFechar(); };

    const confirmar = async () => {
        if (salvando || erroMotivo) return;
        setSalvando(true);
        try {
            const res = await api({
                method: 'put',
                action: `/orcamentoPagamentoFornecedor/${plano.id}/voltarParaPlanos`,
                token,
                data: { motivo: motivo.trim() },
            });
            toast.success((res && res.data && res.data.msg) || 'O plano voltou para Planos de Pagamento.');
            setSalvando(false);
            onConcluido();
        } catch (err) {
            toast.error((err.response && err.response.data && err.response.data.error) || 'Não foi possível voltar o plano.');
            setSalvando(false);
            onFechar(true);
        }
    };

    return (
        <div className="modal fade show d-block fin-pp fin-pp__modalbg"
            onClick={(e) => { if (e.target === e.currentTarget) fechar(); }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content fin-pp__modal">
                    <div className="fin-pp__modal-head">
                        <span className="fin-pp__modal-head-ic"><FaSync size={17} /></span>
                        <h3 className="fin-pp__modal-title">
                            Voltar para Planos de Pagamento
                            <span className="fin-pp__modal-sub">{plano.fornecedor} · {plano.referencia}</span>
                        </h3>
                        <button type="button" className="fin-pp__modal-close" disabled={salvando} onClick={fechar}><FaTimes size={16} /></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-3">
                            A aprovação do Financeiro é desfeita e o plano volta para a 1ª aba, <strong>Planos de Pagamento</strong>.
                            O operador e os responsáveis do evento recebem o motivo no sininho e por e-mail. O fornecedor não é avisado.
                        </p>
                        <div className="fin-pp__filters">
                            <FinField label="Motivo" required full>
                                <FinTextarea rows={3} style={{ height: 'auto', padding: '10px 14px' }}
                                    maxLength={MOTIVO_VOLTA_MAX}
                                    placeholder="Ex.: NF com CNPJ errado. Peça ao fornecedor a nota correta e anexe de novo."
                                    value={motivo}
                                    onChange={(e) => setMotivo(e.target.value)} />
                            </FinField>
                        </div>
                        <div className="fin-pp__cell-muted" style={{ marginTop: 4 }}>
                            {erroMotivo || (motivo.trim().length + ' / ' + MOTIVO_VOLTA_MAX)}
                        </div>
                    </div>
                    <div className="fin-pp__modal-foot">
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={salvando} onClick={fechar}>Cancelar</button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" disabled={salvando || !!erroMotivo} onClick={confirmar}>
                            <FaSync size={13} /> {salvando ? 'Voltando...' : 'Voltar para Planos de Pagamento'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
